import { DASHBOARD_CONTENT_WRAPPER_WIDTH, DASHBOARD_NAVBAR_WIDTH } from '@anm/styles/constants';
import styled, { css } from 'styled-components';
import { LandingFrameWrapper } from '../../hosting/CustomizationSection/RightPanel/Wrapper';

const fullSizePreviewStyles = css`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 6;
  max-width: unset;
`;

export const Wrapper = styled.div<{ isFullSizePreview: boolean }>`
  flex-grow: 1;
  position: relative;
  ${({ isFullSizePreview }) =>
    isFullSizePreview
      ? fullSizePreviewStyles
      : css`
          max-width: calc(100% - ${DASHBOARD_CONTENT_WRAPPER_WIDTH}px - ${DASHBOARD_NAVBAR_WIDTH}px);
        `};

  ${LandingFrameWrapper} {
    min-height: calc(100vh - 70px);
  }
`;

export const PreviewWrapper = styled.div`
  padding: 38px 20px 0px;
`;
